var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch",class:_vm.value ? 'active' : '',on:{"click":function($event){return _vm.toggle()}}},[_c('div',{staticClass:"circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }